export const DISCLAIMER_TEXT = `Pochtecatl is experimental market intelligence and trading automation software. Nothing on this site is financial advice. Trading involves risk. Backtests and simulations do not guarantee future results. Past performance does not indicate future performance. All data shown is mock/demonstration data unless explicitly labeled otherwise. This is not investment advice. Consult a licensed financial advisor before making any investment decisions.`;

export function renderDisclaimer(): string {
  return `
    <div class="disclaimer-banner">
      <strong>DISCLAIMER:</strong> ${DISCLAIMER_TEXT}
    </div>
  `;
}
